import React, { useEffect, useState } from "react";

import { Row } from '@shadcn/components/ui/row';
import { Col } from '@shadcn/components/ui/col';

import WelcomeComp from "./WelcomeComp";
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { arrayNotNull } from "../../../utilities/utilities";
import useQuery from '../../../helpers/JIFI/useQuery';

import { Link } from "react-router-dom";


import './skelton.css'
import { CardContent, Card } from "@shadcn/components/ui/card";
import { Label } from "@shadcn/components/ui/label";

const countryLookup = {
  "Andorra": "🇦🇩",
  "United Arab Emirates": "🇦🇪",
  "Afghanistan": "🇦🇫",
  "Antigua And Barbuda": "🇦🇬",
  "Anguilla": "🇦🇮",
  "Albania": "🇦🇱",
  "Armenia": "🇦🇲",
  "Angola": "🇦🇴",
  "Antarctica": "🇦🇶",
  "Argentina": "🇦🇷",
  "American Samoa": "🇦🇸",
  "Austria": "🇦🇹",
  "Australia": "🇦🇺",
  "Aruba": "🇦🇼",
  "Aland Islands": "🇦🇽",
  "Azerbaijan": "🇦🇿",
  "Bosnia And Herzegovina": "🇧🇦",
  "Barbados": "🇧🇧",
  "Bangladesh": "🇧🇩",
  "Belgium": "🇧🇪",
  "Burkina Faso": "🇧🇫",
  "Bulgaria": "🇧🇬",
  "Bahrain": "🇧🇭",
  "Burundi": "🇧🇮",
  "Benin": "🇧🇯",
  "Saint Barthelemy": "🇧🇱",
  "Bermuda": "🇧🇲",
  "Brunei Darussalam": "🇧🇳",
  "Bolivia": "🇧🇴",
  "BQ": "🇧🇶",
  "Brazil": "🇧🇷",
  "Bahamas": "🇧🇸",
  "Bhutan": "🇧🇹",
  "Bouvet Island": "🇧🇻",
  "Botswana": "🇧🇼",
  "Belarus": "🇧🇾",
  "Belize": "🇧🇿",
  "Canada": "🇨🇦",
  "Cocos (Keeling) Islands": "🇨🇨",
  "Congo, Democratic Republic": "🇨🇩",
  "Central African Republic": "🇨🇫",
  "Congo": "🇨🇬",
  "Switzerland": "🇨🇭",
  "Cote D'Ivoire": "🇨🇮",
  "Cook Islands": "🇨🇰",
  "Chile": "🇨🇱",
  "Cameroon": "🇨🇲",
  "China": "🇨🇳",
  "Colombia": "🇨🇴",
  "Costa Rica": "🇨🇷",
  "Cuba": "🇨🇺",
  "Cape Verde": "🇨🇻",
  "CW": "🇨🇼",
  "Christmas Island": "🇨🇽",
  "Cyprus": "🇨🇾",
  "Czech Republic": "🇨🇿",
  "Germany": "🇩🇪",
  "Djibouti": "🇩🇯",
  "Denmark": "🇩🇰",
  "Dominica": "🇩🇲",
  "Dominican Republic": "🇩🇴",
  "Algeria": "🇩🇿",
  "Ecuador": "🇪🇨",
  "Estonia": "🇪🇪",
  "Egypt": "🇪🇬",
  "Western Sahara": "🇪🇭",
  "Eritrea": "🇪🇷",
  "Spain": "🇪🇸",
  "Ethiopia": "🇪🇹",
  "Finland": "🇫🇮",
  "Fiji": "🇫🇯",
  "Falkland Islands (Malvinas)": "🇫🇰",
  "Micronesia, Federated States Of": "🇫🇲",
  "Faroe Islands": "🇫🇴",
  "France": "🇫🇷",
  "Gabon": "🇬🇦",
  "United Kingdom": "🇬🇧",
  "Grenada": "🇬🇩",
  "Georgia": "🇬🇪",
  "French Guiana": "🇬🇫",
  "Guernsey": "🇬🇬",
  "Ghana": "🇬🇭",
  "Gibraltar": "🇬🇮",
  "Greenland": "🇬🇱",
  "Gambia": "🇬🇲",
  "Guinea": "🇬🇳",
  "Guadeloupe": "🇬🇵",
  "Equatorial Guinea": "🇬🇶",
  "Greece": "🇬🇷",
  "South Georgia And Sandwich Isl.": "🇬🇸",
  "Guatemala": "🇬🇹",
  "Guam": "🇬🇺",
  "Guinea-Bissau": "🇬🇼",
  "Guyana": "🇬🇾",
  "Hong Kong": "🇭🇰",
  "Heard Island & Mcdonald Islands": "🇭🇲",
  "Honduras": "🇭🇳",
  "Croatia": "🇭🇷",
  "Haiti": "🇭🇹",
  "Hungary": "🇭🇺",
  "Indonesia": "🇮🇩",
  "Ireland": "🇮🇪",
  "Israel": "🇮🇱",
  "Isle Of Man": "🇮🇲",
  "India": "🇮🇳",
  "British Indian Ocean Territory": "🇮🇴",
  "Iraq": "🇮🇶",
  "Iran, Islamic Republic Of": "🇮🇷",
  "Iceland": "🇮🇸",
  "Italy": "🇮🇹",
  "Jersey": "🇯🇪",
  "Jamaica": "🇯🇲",
  "Jordan": "🇯🇴",
  "Japan": "🇯🇵",
  "Kenya": "🇰🇪",
  "Kyrgyzstan": "🇰🇬",
  "Cambodia": "🇰🇭",
  "Kiribati": "🇰🇮",
  "Comoros": "🇰🇲",
  "Saint Kitts And Nevis": "🇰🇳",
  "KP": "🇰🇵",
  "Korea": "🇰🇷",
  "Kuwait": "🇰🇼",
  "Cayman Islands": "🇰🇾",
  "Kazakhstan": "🇰🇿",
  "Lao People's Democratic Republic": "🇱🇦",
  "Lebanon": "🇱🇧",
  "Saint Lucia": "🇱🇨",
  "Liechtenstein": "🇱🇮",
  "Sri Lanka": "🇱🇰",
  "Liberia": "🇱🇷",
  "Lesotho": "🇱🇸",
  "Lithuania": "🇱🇹",
  "Luxembourg": "🇱🇺",
  "Latvia": "🇱🇻",
  "Libyan Arab Jamahiriya": "🇱🇾",
  "Morocco": "🇲🇦",
  "Monaco": "🇲🇨",
  "Moldova": "🇲🇩",
  "Montenegro": "🇲🇪",
  "Saint Martin": "🇲🇫",
  "Madagascar": "🇲🇬",
  "Marshall Islands": "🇲🇭",
  "Macedonia": "🇲🇰",
  "Mali": "🇲🇱",
  "Myanmar": "🇲🇲",
  "Mongolia": "🇲🇳",
  "Macao": "🇲🇴",
  "Northern Mariana Islands": "🇲🇵",
  "Martinique": "🇲🇶",
  "Mauritania": "🇲🇷",
  "Montserrat": "🇲🇸",
  "Malta": "🇲🇹",
  "Mauritius": "🇲🇺",
  "Maldives": "🇲🇻",
  "Malawi": "🇲🇼",
  "Mexico": "🇲🇽",
  "Malaysia": "🇲🇾",
  "Mozambique": "🇲🇿",
  "Namibia": "🇳🇦",
  "New Caledonia": "🇳🇨",
  "Niger": "🇳🇪",
  "Norfolk Island": "🇳🇫",
  "Nigeria": "🇳🇬",
  "Nicaragua": "🇳🇮",
  "Netherlands": "🇳🇱",
  "Norway": "🇳🇴",
  "Nepal": "🇳🇵",
  "Nauru": "🇳🇷",
  "Niue": "🇳🇺",
  "New Zealand": "🇳🇿",
  "Oman": "🇴🇲",
  "Panama": "🇵🇦",
  "Peru": "🇵🇪",
  "French Polynesia": "🇵🇫",
  "Papua New Guinea": "🇵🇬",
  "Philippines": "🇵🇭",
  "Pakistan": "🇵🇰",
  "Poland": "🇵🇱",
  "Saint Pierre And Miquelon": "🇵🇲",
  "Pitcairn": "🇵🇳",
  "Puerto Rico": "🇵🇷",
  "Palestinian Territory, Occupied": "🇵🇸",
  "Portugal": "🇵🇹",
  "Palau": "🇵🇼",
  "Paraguay": "🇵🇾",
  "Qatar": "🇶🇦",
  "Reunion": "🇷🇪",
  "Romania": "🇷🇴",
  "Serbia": "🇷🇸",
  "Russian Federation": "🇷🇺",
  "Rwanda": "🇷🇼",
  "Saudi Arabia": "🇸🇦",
  "Solomon Islands": "🇸🇧",
  "Seychelles": "🇸🇨",
  "Sudan": "🇸🇩",
  "Sweden": "🇸🇪",
  "Singapore": "🇸🇬",
  "Saint Helena": "🇸🇭",
  "Slovenia": "🇸🇮",
  "Svalbard And Jan Mayen": "🇸🇯",
  "Slovakia": "🇸🇰",
  "Sierra Leone": "🇸🇱",
  "San Marino": "🇸🇲",
  "Senegal": "🇸🇳",
  "Somalia": "🇸🇴",
  "Suriname": "🇸🇷",
  "SS": "🇸🇸",
  "Sao Tome And Principe": "🇸🇹",
  "El Salvador": "🇸🇻",
  "SX": "🇸🇽",
  "Syrian Arab Republic": "🇸🇾",
  "Swaziland": "🇸🇿",
  "Turks And Caicos Islands": "🇹🇨",
  "Chad": "🇹🇩",
  "French Southern Territories": "🇹🇫",
  "Togo": "🇹🇬",
  "Thailand": "🇹🇭",
  "Tajikistan": "🇹🇯",
  "Tokelau": "🇹🇰",
  "Timor-Leste": "🇹🇱",
  "Turkmenistan": "🇹🇲",
  "Tunisia": "🇹🇳",
  "Tonga": "🇹🇴",
  "Turkey": "🇹🇷",
  "Trinidad And Tobago": "🇹🇹",
  "Tuvalu": "🇹🇻",
  "Taiwan": "🇹🇼",
  "Tanzania": "🇹🇿",
  "Ukraine": "🇺🇦",
  "Uganda": "🇺🇬",
  "United States Outlying Islands": "🇺🇲",
  "United States": "🇺🇸",
  "Uruguay": "🇺🇾",
  "Uzbekistan": "🇺🇿",
  "Holy See (Vatican City State)": "🇻🇦",
  "Saint Vincent And Grenadines": "🇻🇨",
  "Venezuela": "🇻🇪",
  "Virgin Islands, British": "🇻🇬",
  "Virgin Islands, U.S.": "🇻🇮",
  "Viet Nam": "🇻🇳",
  "Vanuatu": "🇻🇺",
  "Wallis And Futuna": "🇼🇫",
  "Samoa": "🇼🇸",
  "Yemen": "🇾🇪",
  "Mayotte": "🇾🇹",
  "South Africa": "🇿🇦",
  "Zambia": "🇿🇲",
  "Zimbabwe": "🇿🇼"
}

function camelToHeadingCase(str) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space before capital letters
        .replace(/^./, char => char.toUpperCase()); // Capitalize the first letter
}


const Dashboard = ({ props }) => {
    const initialState = {
        reportCard: [
            { key: 'fraudReview', title: "Fraud Review", iconClass: "bx-copy-alt", count: 0, color: 'danger', url: '/orders?' },
            { key: 'zendeskOpenTickets', title: "Zendesk Open Tickets", iconClass: "bx-archive-in", count: 0, color: 'primary', url: '/orders?' },
            { key: 'orderIssues', title: "Order/Stock Issues", iconClass: "bx-purchase-tag-alt", count: 0, color: 'warning', url: '/orders?' }
        ],
        statusCard: [
            { key: 'flagged', title: "Flagged", iconClass: "mdi-flag-outline", count: 0, color: 'danger', url: '/orders?selectedOrder=%255B%2522Flagged%2522%255D&filterOrder=%255B%2522Flagged%2522%255D' },
            { key: 'monogrammed', title: "Monogrammed", iconClass: "mdi mdi-drawing", count: 0, color: 'primary', url: '/orders?selectedStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&filterStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&selectedOrder=%255B%2522Has-personalisation%2522%255D&filterOrder=%255B%2522Has-personalisation%2522%255D' },
            { key: 'ready', title: "Ready To Ship", iconClass: "mdi-truck-outline", count: 0, color: 'warning', url: '/orders?selectedOrder=%255B%2522ready-to-ship%2522%255D&filterOrder=%255B%2522ready-to-ship%2522%255D&selectedStatus=%255B%2522unfulfilled%2522%255D&filterStatus=%255B%2522unfulfilled%2522%255D' },
            { key: 'awaiting', title: "Awaiting Stock", iconClass: "mdi-truck-outline", count: 0, color: 'secondary', url: '/orders/?selectedStatus=%255B%2522awaiting-stock%2522%255D' },
            { key: 'partial', title: "Partially Fulfilled", iconClass: "mdi-progress-check", count: 0, color: 'secondary', url: '/orders/?selectedStatus=%255B%2522partial%2522%255D&filterStatus=%255B%2522partial%2522%255D' },
        ],
        shippingCard: [
            { key: 'sameday', title: "Same Day", iconClass: "mdi-clock-fast", count: 0, color: 'danger', url: '/orders' },
            { key: 'nextday', title: "Next Day", iconClass: "mdi-truck-fast-outline", count: 0, color: 'danger', url: '/orders' },
            { key: 'express', title: "Express", iconClass: "mdi-truck-delivery", count: 0, color: 'danger', url: '/orders/?selectedShipping=%255B%2522express%2522%255D&filterShipping=%255B%2522express%2522%255D&selectedStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&filterStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D' },
            { key: 'standard', title: "Standard", iconClass: "mdi-truck-outline", count: 0, color: 'warning', url: '/orders?selectedShipping=%255B%2522standard%2522%255D&filterShipping=%255B%2522standard%2522%255D&selectedStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&filterStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D' },
            { key: 'pickup', title: "Pickup", iconClass: "mdi-inbox-arrow-down", count: 0, color: 'primary', url: '/orders?selectedShipping=%255B%2522pickup_hq%2522%252C%2522pickup%2522%255D&filterShipping=%255B%2522pickup_hq%2522%252C%2522pickup%2522%255D&selectedStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&filterStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D' },
            { key: 'uber', title: "Uber", fabIcon: "fab fa-uber", count: 0, color: 'secondary', url: '/orders?selectedShipping=%255B%2522Uber%2522%255D&filterShipping=%255B%2522Uber%2522%255D&selectedStatus=%255B%2522awaiting-stock%2522%252C%2522unfulfilled%2522%255D&filterStatus=%255B%2522awaiting-stock%2522%252C%2522unfulfilled%2522%255D' },
          ],
        regionCard: [
            { key: 'australia', title: "Australia", count: 0, url: '/orders/?selectedStatus=%255B%257B%2522label%2522%253A%2522Unfulfilled%2522%252C%2522value%2522%253A%2522unfulfilled%2522%257D%252C%257B%2522label%2522%253A%2522Awaiting%2520Stock%2522%252C%2522value%2522%253A%2522awaiting-stock%2522%257D%255D&filterStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&selectedRegion=%257B%2522label%2522%253A%2522Australia%2522%252C%2522value%2522%253A%2522Australia%2522%257D&filterRegion=%2522Australia%2522' },
            { key: 'china', title: "China", count: 0, url: '/orders/?selectedStatus=%255B%257B%2522label%2522%253A%2522Unfulfilled%2522%252C%2522value%2522%253A%2522unfulfilled%2522%257D%252C%257B%2522label%2522%253A%2522Awaiting%2520Stock%2522%252C%2522value%2522%253A%2522awaiting-stock%2522%257D%255D&filterStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&selectedRegion=%257B%2522label%2522%253A%2522China%2522%252C%2522value%2522%253A%2522China%2522%257D&filterRegion=%2522China%2522' },
            { key: 'international', title: "International", count: 0, url: '/orders/?selectedStatus=%255B%257B%2522label%2522%253A%2522Unfulfilled%2522%252C%2522value%2522%253A%2522unfulfilled%2522%257D%252C%257B%2522label%2522%253A%2522Awaiting%2520Stock%2522%252C%2522value%2522%253A%2522awaiting-stock%2522%257D%255D&filterStatus=%255B%2522unfulfilled%2522%252C%2522awaiting-stock%2522%255D&selectedRegion=%257B%2522label%2522%253A%2522International%2522%252C%2522value%2522%253A%2522International%2522%257D&filterRegion=%2522International%2522' }
        ],
        approvalCard: [
            { key: 'approvals', title: "Approvals", count: 0, url: '/approvals' },
        ],
        replenishCard: [
            { key: 'pendingEWE', title: "EWE DROPS", count: 0, url: '/bookEWE' },
        ],
        flagTypeCart: [
            { key: 'cancellation', title: "Cancellation", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%257B%2522label%2522%253A%2522Cancellation%2522%252C%2522value%2522%253A%2522637ac735edde8a0e0f297017%2522%257D%255D&filterFlagType=%255B%2522637ac735edde8a0e0f297017%2522%255D' },
            { key: 'fraud', title: "Fraud", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%2522637b09d5913a570e12fb4882%2522%255D&filterFlagType=%255B%2522637b09d5913a570e12fb4882%2522%255D'},
            { key: 'onhold', title: "On Hold", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%252263747fbe6e76212105356e89%2522%255D&filterFlagType=%255B%252263747fbe6e76212105356e89%2522%255D'},
            { key: 'orderAmendment', title: "Order Amendment ", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%2522638027d42ca6d70de7eb17f3%2522%255D&filterFlagType=%255B%2522638027d42ca6d70de7eb17f3%2522%255D'},
            { key: 'outOfStock', title: "Out of Stock ", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%2522639150744abc2b0e001a657e%2522%255D&filterFlagType=%255B%2522639150744abc2b0e001a657e%2522%255D'},
            { key: 'waitResponse', title: "OOS - Waiting for Response", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%252264990d52216d3926ad651645%2522%255D&filterFlagType=%255B%252264990d52216d3926ad651645%2522%255D'},
            { key: 'pendingRetailChange', title: "Pending retail changes", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%252264b4786529c83526aee2f4af%2522%255D&filterFlagType=%255B%252264b4786529c83526aee2f4af%2522%255D'},
            { key: 'fulfilment', title: "BMPRO Fulfilment", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%252264dab0300b53c626aea8d9a9%2522%255D&filterFlagType=%255B%252264dab0300b53c626aea8d9a9%2522%255D'},
            { key: 'retailStockTransfer', title: "Retail Stock Transfer", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%25226668e77d4610bb4b5fb7815f%2522%255D&filterFlagType=%255B%25226668e77d4610bb4b5fb7815f%2522%255D'},
            { key: 'pendingTracking', title: "Pending - Tracking Update", iconClass: "mdi-flag-outline", color: 'danger', url: '/orders?selectedFlagType=%255B%25226668e7a03b0e4bb0f5598a7f%2522%255D&filterFlagType=%255B%25226668e7a03b0e4bb0f5598a7f%2522%255D'},
        ],
        newOrders: 0,
        corp: 0
    }
    const [stateData, setStateData] = useState(initialState);

    const [data, state] = useQuery({ url: "/dashboard/details", queryData: {} });

    const [monogramData, monogramState] = useQuery({ url: "/dashboard/monogram", queryData: {} });
    
    const completeMonograms = Object.keys(monogramData?.completed || {}).map(key => ({key, title: camelToHeadingCase(key), count: monogramData?.completed[key]}))
    const uncompletedMonograms = [
        {
            "title": "Print",
            "key": "printJobs",
            "count": monogramData ? (monogramData?.stand?.printJobs + monogramData?.corp?.printJobs) : 0
        },
        {
            "title": "Embroidery",
            "key": "embroideryJobs",
            "count": monogramData ? (monogramData?.stand?.embroideryJobs + monogramData?.corp?.embroideryJobs) : 0
        },
        {
            "title": "Awaiting Stock",
            "key": "awaitingJobs",
            "count": monogramData ? (monogramData?.stand?.awaitingJobs + monogramData?.corp?.awaitingJobs) : 0
        }
    ]
    
    
    const dashboard = data && data.data

    useEffect(() => {
        if (dashboard) {
            let { regionCard, statusCard, approvalCard, shippingCard, replenishCard, flagTypeCart } = { ...stateData };
            regionCard && regionCard.map((card, i) => {
                regionCard[i].count = dashboard[`${card.key}`]
            });
            statusCard && statusCard.map((card, i) => {
                statusCard[i].count = dashboard[`${card.key}`]
            });
            approvalCard && approvalCard.map((card, i) => {
                approvalCard[i].count = dashboard[`${card.key}`]
            });
            replenishCard && replenishCard.map((card, i) => {
                replenishCard[i].count = dashboard[`${card.key}`]
            });
            shippingCard && shippingCard.map((card, i) => {
                shippingCard[i].count = dashboard[`${card.key}`]
            });
            setStateData((prevState => {
                return {
                    ...prevState,
                    newOrders: dashboard ? dashboard.newOrder : 0,
                    corp: dashboard ? dashboard.corp : 0,
                    regionCard: regionCard,
                    statusCard: statusCard,
                    approvalCard: approvalCard,
                    replenishCard: replenishCard,
                    flagTypeCart: flagTypeCart,
                }
            }))
        }
    }, [dashboard])

    const user = JSON.parse(localStorage.getItem("authUser"))

    const { reportCard, statusCard, regionCard, approvalCard, shippingCard, replenishCard, flagTypeCart } = stateData;
    return (
        <React.Fragment>
            <div className="page-content">
                <div className="mx-auto px-4 xl:max-w-[85%]">
                    {/* Render Breadcrumb */}
                    <Breadcrumbs title="Dashboard" breadcrumbItem="Dashboard" />
                    <Row className="flex-wrap">
                        <Col className="xl:w-5/12 pr-3">
                            <WelcomeComp monogramData={monogramData} stateData={stateData} dashboard={dashboard} />
                            {/* <TopCities /> */}
                            <Label className="!my-5">
                                Uncompleted Monograms
                            </Label>
                            <div className="relative">
                            <div class="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 via-gray-50/50 to-transparent pointer-events-none"></div>
                                <Row className="overflow-x-scroll gap-3 ">
                                    {arrayNotNull(uncompletedMonograms) && uncompletedMonograms.sort((a,b) => b.count - a.count).map((region, key) =>
                                        <Col className="min-w-[200px]" key={`_col_1_${key}`}>
                                            <Card className="mini-stats-wid ">
                                            <CardContent className={"p-4 border-solid border-[1av] border-black rounded-md"}>
                                                    <div className="flex items-start space-x-4">
                                                        <div className="flex-1" body>
                                                            <p className="text-slateGray font-weight-medium !mb-4">{region.title || 'Unknown'}</p>
                                                            <h4 className={`mb-0 text-lg ${dashboard ? '' : 'placeholder'}`}>{dashboard ? region.count: ' '}</h4>
                                                        </div>
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </Col>
                                    )}
                                </Row>
                            </div>
                            <Label className="!my-5">
                                Completed Monograms
                            </Label>
                            <div className="relative">
                            <div class="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 via-gray-50/50 to-transparent pointer-events-none"></div>

                            <Row className="overflow-x-scroll gap-3">
                                {arrayNotNull(completeMonograms) && completeMonograms.sort((a,b) => b.count - a.count).map((region, key) =>
                                    <Col className="min-w-[200px]" key={`_col_1_${key}`}>
                                        <Card className="mini-stats-wid ">
                                        <CardContent className={"p-4 border-solid border-[1av] border-black rounded-md"}>
                                                <div className="flex items-start space-x-4">
                                                    <div className="flex-1" body>
                                                        <p className="text-slateGray font-weight-medium !mb-4">{region.title || 'Unknown'}</p>
                                                        <h4 className={`mb-0 text-lg ${dashboard ? '' : 'placeholder'}`}>{dashboard ? region.count: ' '}</h4>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </Col>
                                )}
                            </Row>
                                </div>
                        </Col>
                        <Col className="xl:w-7/12 pl-3">
                            {
                                (
                                    user.permissions.includes('BookStockDrop') ||
                                    user.permissions.includes('ViewApprovals')
                                ) && (
                                    <>
                                        <Label>
                                            PENDING:
                                        </Label>
                                        <Row className="flex-row gap-3">
                                            {
                                                user.permissions.includes('BookStockDrop') && (
                                                    <Col sm="6" className="sm:w-[49%]">
                                                        <Row>
                                                            {arrayNotNull(replenishCard) && replenishCard.map((region, key) =>
                                                                <Col className="w-full" key={`_col_1_${key}`}>
                                                                    <Link to={region.url}>
                                                                        <Card className="mini-stats-wid ">
                                                                            <CardContent className={"p-4 border-solid border-[1av] border-black rounded-md"}>
                                                                                <div className="flex items-start space-x-4">
                                                                                    <div className="flex-1" >
                                                                                        <p className="text-slateGray font-weight-medium !mb-4">{region.title}</p>
                                                                                        <h4 className={`mb-0 text-lg ${dashboard ? '' : 'placeholder'}`}>{dashboard ? region.count : ' '}</h4>
                                                                                    </div>
                                                                                </div>
                                                                            </CardContent>
                                                                        </Card>
                                                                    </Link>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </Col>
                                                )
                                            }
                                            {
                                                user.permissions.includes('ViewApprovals')  && (
                                                    <Col  className="sm:w-6/12">
                                                        <Row>
                                                            {arrayNotNull(approvalCard) && approvalCard.map((region, key) =>
                                                                <Col className="w-full" key={`_col_1_${key}`}>
                                                                    <Link to={region.url}>
                                                                        <Card className="mini-stats-wid  ">
                                                                        <CardContent className={"p-4 border-solid border-[1av] border-black rounded-md"}>
                                                                                <div className="flex items-start space-x-4">
                                                                                    <div className="flex-1">
                                                                                        <p className="text-slateGray font-weight-medium !mb-4">{region.title}</p>
                                                                                        <h4 className={`mb-0 text-lg ${dashboard ? '' : 'placeholder'}`}>{dashboard ? region.count : ' '}</h4>
                                                                                    </div>
                                                                                </div>
                                                                            </CardContent>
                                                                        </Card>
                                                                    </Link>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </Col>
                                                )
                                            }
                                        </Row>
                                    </>
                                )
                            }
                            <Label className="!my-5">
                                UNFULFILLED ORDERS BY STATUS:
                            </Label>
                            <div className="relative">
                            <div class="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 via-gray-50/50 to-transparent pointer-events-none"></div>

                            <Row className="overflow-x-scroll gap-3">
                                {arrayNotNull(statusCard) && statusCard.sort((a,b) => b.count - a.count).map((status, key) =>
                                    <Col  className="min-w-[250px]" key={`_col_0_${key}`}>
                                        <Link to={status.url}>
                                            <Card className="mini-stats-wid  ">
                                            <CardContent className={"p-4 border-solid border-[1av] border-black rounded-md"}>
                                                    <div className="flex items-start space-x-4">
                                                        <div className="flex-1" body>
                                                            <p className="text-slateGray font-weight-medium !mb-4">{status.title}</p>
                                                            <h4 className={`mb-0 text-lg ${dashboard ? '' : 'placeholder'}`}>{dashboard ? status.count : ' '}</h4>
                                                        </div>
                                                        <div className={`mini-stat-icon avatar-sm rounded-circle bg-${status.color} d-flex align-items-center justify-content-center`}>
                                                            <span className="">
                                                                {
                                                                    status.fabIcon ? <i className={`text-white ${status.iconClass} font-size-24`}></i> : <i className={`text-white mdi ${status.iconClass} font-size-24`}></i>
                                                                }
                                                                <img />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </Link>
                                    </Col>
                                )}
                            </Row>
                            </div>
                            <Label className="!my-5">
                                FLAGGED ORDERS BY TYPES:
                            </Label>
                            <div className="relative">
                            <div class="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 via-gray-50/50 to-transparent pointer-events-none"></div>

                            <Row className="overflow-x-scroll gap-3">
                                {arrayNotNull(dashboard?.flaggedCounts) && dashboard?.flaggedCounts.sort((a,b) => b.flaggedCount - a.flaggedCount).map((flaggedType, key) =>
                                    <Col className="min-w-[250px]" key={`_col_1_${key}`}>
                                        <Link to={flagTypeCart.find(element => element.title === flaggedType._id)?.url ?? '#'}>
                                            <Card className="mini-stats-wid  ">
                                            <CardContent className={"p-4 border-solid border-[1av] border-black rounded-md"}>
                                                    <div className="flex items-start space-x-4">
                                                        <div className="flex-1">
                                                            <p className="text-slateGray font-weight-medium !mb-4">{flaggedType._id ?? 'Unknown'}</p>
                                                            <h4 className={`mb-0 text-lg ${dashboard ? '' : 'placeholder'}`}>{dashboard ? flaggedType.flaggedCount: ' '}</h4>
                                                        </div>
                                                        <div className={`mini-stat-icon avatar-sm rounded-circle bg-danger d-flex align-items-center justify-content-center`}>
                                                            <span className="" style={{fontSize: 32}}>
                                                                <i className={`text-white mdi mdi-flag-outline font-size-24`}></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </Link>
                                    </Col>
                                )}
                            </Row>
                            </div>``
                        <Label className="!my-5">
                                UNFULFILLED ORDERS BY SHIPPING:
                            </Label>
                            <div className="relative">
                            <div class="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 via-gray-50/50 to-transparent pointer-events-none"></div>

                            <Row className="overflow-x-scroll gap-3">
                                {arrayNotNull(shippingCard) && shippingCard.sort((a,b) => b.count - a.count).map((status, key) =>
                                    <Col className="min-w-[250px]" key={`_col_0_${key}`}>
                                        <Link to={status.url}>
                                            <Card className="mini-stats-wid  ">
                                            <CardContent className={"p-4 border-solid border-[1av] border-black rounded-md"}>
                                                    <div className="flex items-start space-x-4">
                                                        <div className="flex-1" body>
                                                            <p className="text-slateGray font-weight-medium !mb-4">{status.title}</p>
                                                            <h4 className={`mb-0 text-lg ${dashboard ? '' : 'placeholder'}`}>{dashboard ? status.count : ' '}</h4>
                                                        </div>
                                                        <div className={`mini-stat-icon avatar-sm rounded-circle bg-${status.color} d-flex align-items-center justify-content-center`}>
                                                            <span className="">
                                                                {
                                                                    status.fabIcon ? <i className={`text-white ${status.iconClass} font-size-24`}></i> : <i className={`text-white mdi ${status.iconClass} font-size-24`}></i>
                                                                }
                                                                <img />
                                                            </span>
                                                        </div>
                                                    </div>
                                                </CardContent>
                                            </Card>
                                        </Link>
                                    </Col>
                                )}
                            </Row>
                            </div>
                            <Label className="!my-5">
                                UNFULFILLED ORDERS BY REGION:
                            </Label>
                            <div className="relative">
                            <div class="absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-gray-50 via-gray-50/50 to-transparent pointer-events-none"></div>

                            <Row className="overflow-x-scroll gap-3">
                                {arrayNotNull(dashboard?.countryCounts) && dashboard?.countryCounts.sort((a,b) => b.countryCount - a.countryCount).map((region, key) =>
                                    <Col className="min-w-[250px]" key={`_col_1_${key}`}>
                                        <Card className="mini-stats-wid ">
                                        <CardContent className={"p-4 border-solid border-[1av] border-black rounded-md"}>
                                                <div className="flex items-start space-x-4">
                                                    <div className="flex-1" body>
                                                        <p className="text-slateGray font-weight-medium !mb-4">{region._id || 'Unknown'}</p>
                                                        <h4 className={`mb-0 text-lg ${dashboard ? '' : 'placeholder'}`}>{dashboard ? region.countryCount: ' '}</h4>
                                                    </div>
                                                    <div className={`mini-stat-icon avatar-sm rounded-circle bg-warning d-flex align-items-center justify-content-center`}>
                                                        <span className="avatar-title" style={{fontSize: 32}}>
                                                            {countryLookup[region._id]}
                                                        </span>
                                                    </div>
                                                </div>
                                            </CardContent>
                                        </Card>
                                    </Col>
                                )}
                            </Row>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Dashboard;
